import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cdc1d3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2cdc1d3c&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2cdc1d3c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc1d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cdc1d3c')) {
      api.createRecord('2cdc1d3c', component.options)
    } else {
      api.reload('2cdc1d3c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cdc1d3c&scoped=true", function () {
      api.rerender('2cdc1d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TagManage/index.vue"
export default component.exports